import checkoutUtils from '@lib/checkout'

export const markupFee = (booking: Booking.Info): number => checkoutUtils.calculateTotalFees(booking.fees)

export const priceWithOutFee = (booking: Booking.Info): number => booking.totalPrice.fractional - markupFee(booking)

export const totalPrice = (booking: Booking.Info): number =>
  booking.installment ? booking.installment.totalAmount : booking.totalPrice.fractional
